// extracted by mini-css-extract-plugin
export default {"sparkle":"sparkle--vynlL","sparkles-come-in-out":"sparkles-come-in-out--SW2vY","sparkles-spin":"sparkles-spin--ERPZL","sparkles-area-overlay":"sparkles-area-overlay--EAZmz"};